import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

// attach token automatically
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("cinelut_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const buildUrl = (relative) => {
  if (!relative) return "";
  if (relative.startsWith("http")) return relative;
  return `${BACKEND_URL}${relative}`;
};
